const asyncTypes = [
  'REQUEST',
  'SUCCESS',
  'ERROR',
];

export const createAsyncTypes = actionString =>
  asyncTypes.reduce((result, asyncType) => {
    result[asyncType] = `${actionString}_${asyncType}`;
    return result;
  }, {});

export const createReducer =
  (initialState, handlers) =>
    (state = initialState, action) => {
      const handler = handlers[action.type];

      return (handler)
        ? handler(state, action)
        : state;
    };



// WEBPACK FOOTER //
// ./src/redux/utils.js